import { Snackbar, SnackbarContent } from "@material-ui/core";
import * as React from "react";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

interface IProps {
  msg: string;
  type?: string;
  open: boolean;
  onClose: () => void;
}

// tslint:disable-next-line:no-empty-interface
interface IState {}

export class CustomSnackbar extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <Snackbar
        anchorOrigin={{
          horizontal: "center",
          vertical: "center",
        }}
        open={this.props.open}
        autoHideDuration={4000}
        onClose={this.onCloseSnack}
        style={{ marginTop: '5px' }}
      >
        <SnackbarContent message={this.props.msg} style={this.snackStyle()} />
      </Snackbar>
    );
  }

  private snackStyle = () => {
    return !!this.props.type && styles[this.props.type];
  };

  private onCloseSnack = (event: object, reason: string) => {
    if (reason === "clickaway") {
      return;
    }
    this.props.onClose();
  };
}



// WEBPACK FOOTER //
// ./src/component/shared/snackbar/CustomSnackbar.tsx